<p-dialog [(visible)]="!directToStep1 && showDialog" [position]="position" [modal]="true" class="order-setup-dialog"
    [style]="{width: (createFromPrevious) ? '720px': '560px', maxHeight: '600px'}" [maximizable]="true"
    [baseZIndex]="1" [draggable]="false" [resizable]="false" class="order-setup-dialog"
    [ngClass]="{'remove-footer': !showFooter}" (onHide)="onClose()">
    <p-header>
        <a *ngIf="canGoBack" (click)="moveForward(false)" class="anchor m-r-12"><i class="ei ei-arrow-left"></i></a>
        <span class="p-dialog-title">{{headerTitle}}<span class="optional"
                *ngIf="orderSetupType == OrderSetupType.ORDERNAME"></span></span>
    </p-header>
    <div class="selection-box" *ngIf="orderSetupContext?.transactionalData?.account?.name && !abstractPopUp">
        <div class="form-horizontal form-compressed">
            <div class="form-group">
                <div class="form-label-div" *ngIf="orderSetupContext.transactionalData.account.name">
                    <span class="form-label">{{'vbeiAccount' | translate}}</span>
                </div>
                <div class="form-input-div">
                    <span>{{orderSetupContext.transactionalData.account | accountDisplay}}&nbsp;
                        <span class="default-text green"
                            *ngIf="orderSetupContext.transactionalData.account.isDefaultAccount">{{'DEFAULT' | translate}}</span>
                    </span>
                </div>
            </div>
            <div class="form-group" *ngIf="orderSetupContext.transactionalData.orderTemplate.name">
                <div class="form-label-div">
                    <span class="form-label">{{'vbeiOrderTemplate' | translate}}</span>
                </div>
                <div class="form-input-div">
                    <span>{{orderSetupContext.transactionalData.orderTemplate.name}}&nbsp;
                        <span class="default-text green"
                            *ngIf="orderSetupContext.transactionalData.orderTemplate.isDefaultOrderingService">{{'DEFAULT' | translate}}</span>
                    </span>
                </div>
            </div>
            <div class="form-group" *ngIf="orderSetupContext.transactionalData.quotation.name">
                <div class="form-label-div">
                    <span class="form-label">{{'vbeiQuotation' | translate}}</span>
                </div>
                <div class="form-input-div">
                    <span>{{orderSetupContext.transactionalData.quotation | quotationDisplay}}&nbsp;
                        <span class="default-text green"
                            *ngIf="orderSetupContext.transactionalData.quotation.isDefaultQuotation">{{'DEFAULT' | translate}}</span>
                    </span>
                </div>
            </div>
            <div class="form-group" *ngIf="orderSetupContext.transactionalData.contract.name">
                <div class="form-label-div">
                    <span class="form-label">{{'vbeiContract' | translate}}</span>
                </div>
                <div class="form-input-div">
                    <span>{{orderSetupContext.transactionalData.contract | contractDisplay}}&nbsp;
                        <span class="default-text green"
                            *ngIf="orderSetupContext.transactionalData.contract.isDefaultContract">{{'DEFAULT' | translate}}</span>
                    </span>
                </div>
            </div>
            <div class="form-group" *ngIf="orderSetupContext.transactionalData.quotation.salesPartnerName">
                <div class="form-label-div">
                    <span class="form-label">{{'vbeiReceivingLab' | translate}}</span>
                </div>
                <div class="form-input-div">{{orderSetupContext.transactionalData.quotation.receivingLabName}}</div>
            </div>
        </div>
    </div>
    <app-account *ngIf="orderSetupType == OrderSetupType.ACCOUNT" [options]="orderSetupContext.masterData.accounts"
        [selectedValue]="orderSetupContext.transactionalData.account" (selection)="onAccountSelection($event)">
    </app-account>

    <app-order-template *ngIf="orderSetupType == OrderSetupType.ORDERTEMPLATE"
        [options]="orderSetupContext.masterData.orderTemplates"
        [selectedValue]="orderSetupContext.transactionalData.orderTemplate"
        (selection)="onOrderTemplateSelection($event)">
    </app-order-template>

    <app-quotation *ngIf="orderSetupType == orderStep.QUOTATION" [options]="orderSetupContext.masterData.quotations"
        [selectedValue]="orderSetupContext.transactionalData.quotation" (selection)="onQuotationSelection($event)">
    </app-quotation>


    <app-contract *ngIf="orderSetupType == OrderSetupType.CONTRACT" [options]="orderSetupContext.masterData.contracts"
        [selectedValue]="orderSetupContext.transactionalData.contract" (selection)="onContractSelection($event)"
        (moveBack)="noContractAvailable()">
    </app-contract>

    <div class="text-data" *ngIf="orderSetupType == OrderSetupType.ORDERNAME">
        <div [formGroup]="orderNameForm">
            <div class="form-input-div">
                <input formControlName="OrderName" id="OrderName" type="text" pInputText placeholder="{{'vbeiEnterOrderName'| translate}}"
                    [appErrorMessage]="orderNameForm.get('OrderName')" maxlength="50"
                    [(ngModel)]="orderSetupContext.transactionalData.OrderName"
                    (change)="changeOrderName(orderNameForm.get('OrderName').value)" [ngClass]="{'has-error': (orderNameForm.get('OrderName').dirty 
                    || orderNameForm.get('OrderName').touched) && orderNameForm.get('OrderName').errors}" />
            </div>
        </div>
    </div>
    <p-footer *ngIf="!abstractPopUp">
        <button type="button" [disabled]="!canContinue()" pButton (click)="continueOrder()" label="{{'vbeiContinue' | translate}}"></button>
    </p-footer>
</p-dialog>